import { https , httpsFile } from './http.js';

export function index () {
    return https().get('material-group3');
}

export function getMatGrp3 (search,offset) {
    return https().get(`getMatGrp3?search=${search}&offset=${offset}`);
}